// extracted by css-extract-rspack-plugin
export default {"iframe":"_9de23f65","thumbnail":"_7492073d"};